<template>
  <md-card
    class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-45"
    style="cursor: pointer; height: 200px"
    :class="showProjects ? 'projectView' : ''"
  >
    <div @click="toggleShowProject()">
      <div
        style="display: flex; justify-content: space-between; padding: 10px"
        v-if="!showProjects"
      >
        <div
          class="col-4"
          style="
            padding: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
          "
        >
          <div style="min-height: 125px; display: flex; align-items: center">
            <img
              :src="
                'data:image/' +
                item.asset_image.extension +
                ';base64,' +
                item.asset_image.image
              "
              alt=""
            />
          </div>
          <p style="font-weight: bold; margin-top: 10px">
            {{ item.name }}
          </p>
        </div>
        <div
          class="col-7"
          style="
            padding: 10px;
            justify-content: center;
            display: flex;
            flex-direction: column;
          "
        >
          <p style="font-weight: bold; margin-top: 10px">
            {{ item.code }}
          </p>
          <p style="font-size: 13px; font-weight: 500; text-align: justify">
            {{ item.description }}
          </p>
          <p
            style="
              font-size: 13px;
              font-weight: 500;
              text-align: justify;
              margin: 0;
            "
          >
            Projects Count: {{ item.projects_count }}
          </p>
          <p
            style="
              font-size: 13px;
              font-weight: 500;
              text-align: justify;
              margin: 0;
            "
          >
            Allocation Ratio: {{ item.asset_allocation_ratio.toFixed(2) }}%
          </p>
        </div>
      </div>
      <div v-else-if="showProjects" style="height: 200px" class="col-12">
        <div
          style="
            display: flex;
            justify-content: end;
            margin: 8px;
            padding: 10px;
          "
          class="col-12"
        >
          <button
            style="
              border-radius: 30px;
              padding-top: 0px;
              padding-left: 7px;
              padding-right: 7px;
              padding-bottom: 0px;
              margin-right: 10px;
            "
            type="button"
            class="btn btn-warning"
            @click="(event) => emitUpdate(event, item)"
          >
            <i style="font-size: 12px; color: white" class="fa fa-arrow-up"></i>
          </button>
          <button
            style="
              border-radius: 30px;
              padding-top: 0px;
              padding-left: 7px;
              padding-right: 7px;
              padding-bottom: 0px;
            "
            @click="(event) => emitDelete(event, item)"
            type="button"
            class="btn btn-danger"
          >
            <i style="font-size: 12px" class="fa fa-trash"></i>
          </button>
        </div>
      </div>
    </div>
  </md-card>
</template>
<script>
export default {
  name: "asset",
  props: ["item"],
  data() {
    return {
      showProjects: false,
    };
  },
  components: {},
  methods: {
    toggleShowProject() {
      this.showProjects = !this.showProjects;
    },
    emitUpdate(event, asset) {
      this.$emit("event", { name: "updateAsset", payload: asset });
      event.preventDefault();
    },
    emitDelete(event, asset) {
      this.$emit("event", { name: "deleteAsset", payload: asset.id });
      event.preventDefault();
    },
  },
};
</script>
<style scoped>
.projectView {
  background-color: #707070;
}
</style>



// WEBPACK FOOTER //
// resources/js/pages/Layouts/Items/asset.vue